<template>
    <div class="sortcard" :class="number==0?'top1':number==1?'top2':'top3'" @click="goPageDetail()">
        <div v-if="origin==2" class="cardhead">
            <img v-if="number==0" src="@/assets/images/home/top1.png" alt="">
            <img v-if="number==1" src="@/assets/images/home/top2.png" alt="">
            <img v-if="number==2" src="@/assets/images/home/top3.png" alt="">
        </div>
        <div v-else class="cardhead2">
            <img :class="number==0?'border1':number==1?'border2':'border3'" :src="detail.headImg" alt="">
        </div>
        <div class="text">
            <p v-if="number==0" class="top1 p1">{{ $t('components.sortCard.486477-0') }}</p>
            <p v-if="number==1" class="top2 p1">{{ $t('components.sortCard.486477-1') }}</p>
            <p v-if="number==2" class="top3 p1">{{ $t('components.sortCard.486477-2') }}</p>
            <p class="name" :title="detail.ownerName">{{detail.ownerName}}</p>
            <p class="p2">{{detail.resCount}}{{ $t('components.sortCard.486477-3') }}</p>
            <p class="p3">（ {{text}} ）</p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        detail:{
            type:Object,
            default:()=>{}
        },
        number:{
            type:Number,
            default:0
        },
        origin:{
            type:Number,
            default:1
        },
        text:{
            type:String,
            default:''
        },

    },
    methods:{
        goPageDetail(){
            this.origin==1 && this.$router.push({path:'/teacherClass/space/home',query:{userId:this.detail.ownerId}});
            this.origin==2 && this.$router.push({path:'/schoolClass/space/home',query:{orgId:this.detail.ownerId}});
        }
    }
}
</script>
<style lang="less" scoped>
.sortcard{
    width:130px;
    height: 195px;
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    .cardhead{
        position: absolute;
        left:50%;
        top:-37px;
        margin-left:-37px;
        img{
            width:74px;
            height: 74px;
            border-radius: 50%;
            overflow: hidden;
        }
    }
    .cardhead2{
        position: absolute;
        left:50%;
        top:-27px;
        margin-left:-27px;
        img{
            width:54px;
            height: 54px;
            border-radius: 50%;
            overflow: hidden;
        }
    }
    .text{
        text-align: center;
        overflow: hidden;
        margin:0 16px;
        .p1{
            margin-top:40px;
            font-size: 13px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
        }
        .name{
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            color: #333333;
            margin-top:16px;
            height: 38px;
            .overflow2;
        }
        .p2{
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            margin-top:19px;
        }
        .p3{
            font-size: 13px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #666666;
            margin-top:6px;

        }
    }
}
.overflow2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
.top1{
    background: #FFF4D6;
    color: #D8A442;
}
.top2{
    background: #EDEDED;
    color: #666666;
}
.top3{
    background: #FFEFDE;
    color: #C16F1E;
}
.border1{
    border:4px solid #EAB830;
}
.border2{
    border:4px solid #c7c6c6;
}
.border3{
    border:4px solid #C16F1E;
}
</style>